import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { WidgetHelperService } from '../widget-helper.service';
import { CommonService } from '../../../services';

@Component({ selector: 'histogram', templateUrl: './histogram.component.html', styleUrls: ['./histogram.component.scss'], encapsulation: ViewEncapsulation.None })
export class HistogramComponent implements OnInit {
    @Input('componentData') componentData: any;
    @Input('OffsetValue') offset: any;
    @Input('groupData') groupData: any;
    options: any;
    columnChart;
    highChartOption: any;
    constructor(private widgetHelperService: WidgetHelperService, private commonService: CommonService) { }

    ngOnChanges() {
        if (this.columnChart) {
            for (var i = this.columnChart.series.length - 1; i >= 0; i--) {
                this.columnChart.series[i].remove();
            }
            //add new points
            this.widgetHelperService.getSeriesData(this.componentData).forEach((obj, i) => {
                this.columnChart.addSeries(obj);
            });
        }
    }

    ngOnInit() {

        //set default data
        this.options = {
            chart: {
                type: "column",
            },
            credits: {
                enabled: false
            },
            xAxis: this.widgetHelperService.getXAxisConfigForHistogram(this.componentData, this.groupData),
            yAxis: this.widgetHelperService.getYAxisConfig(this.componentData),
            tooltip: {
                // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                //     '<td style="padding:0"><b>{point.y}</b></td></tr>',
                // footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            title: {
                text: ''
            },
            plotOptions: {
                series: {
                    turboThreshold: 5000,
                    boostThreshold: 100
                },
                column: {
                    pointPadding: 0,
                    borderWidth: 0,
                    groupPadding: 0.01,
                    shadow: false
                }
            },
            series: this.widgetHelperService.getHistogramSeriesData(this.componentData)
        };

    }

    saveInstance(chartInstance) {
        this.columnChart = chartInstance;
    }

    onLegendTitleClick(clickevent) {
        setTimeout(() => {
            let hiddenLegends = this.columnChart.legend.allItems.map(l => (!l.visible ? l.name : ""));
            this.columnChart.xAxis[0].plotLinesAndBands.forEach((pb, i) => {
                let eventId = pb.id;
                hiddenLegends.forEach(hl => {
                    eventId = eventId.replace(hl, "");
                });
                if (eventId.trim() == "e_") {
                    this.columnChart.xAxis[0].plotLinesAndBands[i].hidden = true;
                    this.columnChart.xAxis[0].plotLinesAndBands[i].svgElem.hide();
                    this.columnChart.xAxis[0].plotLinesAndBands[i].label.hide();
                } else {
                    this.columnChart.xAxis[0].plotLinesAndBands[i].hidden = false;
                    this.columnChart.xAxis[0].plotLinesAndBands[i].svgElem.show();
                    this.columnChart.xAxis[0].plotLinesAndBands[i].label.show();
                }
            });
            try {
                this.columnChart.update(this.columnChart);
            } catch (e) { }
        }, 5)

    }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/histogram/histogram.component.ts